var path = '/templates/projects.dashboard/dashboard.html';
var html = "<div class=\"content site-dashboard\"><div class=row><div class=col-md-12><div ng-if=$ctrl.project.thisMonthStat class=gridster><ul><li id=\"{{ chart.name }}\" class=gs-w ng-init=\"$last && $ctrl.initGrid()\" ng-repeat=\"chart in $ctrl.chartPositions\" data-row=\"{{ chart.row }}\" data-col=\"{{ chart.col }}\" data-sizex=\"{{ chart.size_x }}\" data-sizey=\"{{ chart.size_y }}\"><zc-dashboard-chart-loader chart=chart project=$ctrl.project></zc-dashboard-chart-loader></li></ul></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.dashboard/dashboard.html
// module id = 1451
// module chunks = 0